module.exports = __webpack_public_path__ + "static/img/042统战H5页面1.e18ce98.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/042统战H5页面1.jpg
// module id = 9BWl
// module chunks = 0